import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';

export default function NotAuthorized() {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <div className="vp-root" style={{
      minHeight: '100vh',
      background: 'var(--vp-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{
        maxWidth: 440, textAlign: 'center',
        padding: 32, background: 'var(--vp-surface)',
        border: '1px solid var(--vp-border)', borderRadius: 'var(--vp-r-lg)',
        boxShadow: 'var(--vp-shadow-md)',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: 'var(--vp-danger-soft)', color: 'var(--vp-danger)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24, marginBottom: 16,
        }}>
          <i className="bi bi-lock" />
        </div>
        <h1 style={{ fontSize: 'var(--vp-text-xl)', margin: '0 0 6px', color: 'var(--vp-text)' }}>
          Non hai accesso a questa risorsa
        </h1>
        <p style={{ color: 'var(--vp-text-3)', fontSize: 'var(--vp-text-sm)', margin: '0 0 20px' }}>
          La tua membership non include il tenant o il ruolo richiesto. Contatta un amministratore se pensi sia un errore.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <Button color="primary" size="sm" onClick={() => navigate('/', { replace: true })}>
            Torna alla home
          </Button>
          <Button color="light" size="sm" onClick={() => void auth.signoutRedirect()}>
            Esci
          </Button>
        </div>
      </div>
    </div>
  );
}
